// Serializes Manufacturing Cost Calculator section combination fetches so only ONE heavy solve runs at
// a time. Every section now fetches on page load (there is no "Start Working on This Section" button),
// and each combination fetch runs a heavy solve: in development that solve runs inline in the request
// (LayoutsNavSectionCombinationsJob.perform_now), so two at once deadlock the code-reload interlock; in
// production it is a Sidekiq job, so firing every section at once enqueues a burst of the most expensive
// operation on the page. Running them one after another (in roughly top-to-bottom order — each section
// enqueues once its own default-material-values fetch resolves) keeps the no-button behaviour without
// either problem.
//
// Each caller hands in a task that starts its fetch and returns a promise resolving when that fetch has
// settled (its loading state returned to false). The next task starts only once the current one settles.
let tail = Promise.resolve();

export function runExclusive(task) {
  // Keep the chain going even if a task rejects, so one failed section can't block the rest. Return the
  // caught promise so a caller that ignores the result never surfaces an unhandled rejection.
  tail = tail.then(() => task()).catch(() => {});
  return tail;
}

// Test-only: clear the shared chain so a still-pending fetch from one test cannot hold up the next one.
export function resetForTests() {
  tail = Promise.resolve();
}
